/**
 * Default core settings schema.
 * Generates the singleton form at /admin/settings.
 */
export function defaultSettingsSchema(): string {
  return JSON.stringify(
    {
      name: 'settings',
      type: 'single',
      label: 'Settings',
      description: 'General Settings',
      icon: 'Settings',
      fields: [
        {
          type: 'section',
          name: 'siteSettings',
          label: 'Dashboard Settings',
          description: 'General settings for the dashboard',
          fields: [
            {
              name: 'title',
              type: 'string',
              label: 'Name',
              hint: 'Displayed in the sidebar and throughout the dashboard',
              default: 'BetterStart'
            },
            {
              name: 'dashboardDescription',
              type: 'text',
              label: 'Description',
              hint: 'A brief description of the application'
            }
          ]
        },
        {
          type: 'section',
          name: 'branding',
          label: 'Branding',
          description: 'Logo and visual identity',
          fields: [{ name: 'dashboardLogo', type: 'image', label: 'Logo' }]
        },
        {
          type: 'section',
          name: 'developer',
          label: 'Developer',
          description: 'Developer tools for the dashboard',
          fields: [
            {
              name: 'devMode',
              type: 'boolean',
              label: 'Dev Mode',
              hint: 'Show generated integration snippets and schema details in the dashboard',
              default: true
            }
          ]
        },
        {
          type: 'section',
          name: 'auditLog',
          label: 'Audit Log',
          description: 'Audit retention controls',
          fields: [
            {
              name: 'auditRetentionEnabled',
              type: 'boolean',
              label: 'Enable Retention Cleanup',
              hint: 'Allow admins to permanently delete audit rows older than the retention window',
              default: false
            },
            {
              name: 'auditRetentionDays',
              type: 'number',
              label: 'Retention Days',
              hint: 'Rows older than this many days are deleted when cleanup is run. Leave empty to keep audit rows forever.'
            }
          ]
        }
      ]
    },
    null,
    2
  )
}
